import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { DadosArquivisticosService } from './dados-arquivisticos.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { DialogConfirmComponent } from '../dialog/dialog-confirm/dialog-confirm.component';
import { DadosArquivisticosModel } from './dados-arquivisticos.model';

@Component({
  selector: 'app-dados-arquivisticos',
  templateUrl: './dados-arquivisticos.component.html',
  styleUrls: ['./dados-arquivisticos.component.scss']
})
export class DadosArquivisticosComponent implements OnInit {

  public acervo = false;
  public adm = true;
  public solicitacao = false;
  public loading = true;
  public arquivisticoForm: FormGroup;
  public submit = false;
  public clienteId;
  public tipoId;
  public nodes: any = [];
  public dadosArquivistico: any = [];
  public propriedades: any = [];
  public manual = false;
  public inputDate = false;
  public lista = false;
  public nodeDicionario: any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public propriedadesCadastradas: any = [];
  public dadoEdit = {} as DadosArquivisticosModel;
  public list: any = [];

  constructor(
    private configPastaService: ConfigurarPastaServiceService,
    private route: ActivatedRoute,
    private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private dadosArquivisticoService: DadosArquivisticosService,
    private authService: AuthenticationService) {
      this.route.params.subscribe(params => this.clienteId = params['clienteId']);
      this.route.params.subscribe(params => this.tipoId = params['tipoId']);
     }

  ngOnInit() {
    this.arquivisticoForm = this.fb.group({
      id: [],
      propriedadeAlfresco: [null, Validators.required],
      conteudo: [null, Validators.required],
      nodeDicionario: [null],
      cliente: [null]
    });
    this.getDadosArquivisticos();
    this.getNodeDicionario(this.tipoId);
    this.getCliente(this.clienteId);
    this.getPropriedadesCadastradas();
  }

  selectProp(e) {
    console.log(e);
    if (e.value.name === 'sis:Data-Producao') {
      this.manual = false;
      this.lista = false;
      this.inputDate = true;
    } else if (e.value.name === 'sis:Destinacao-Prevista') {
      this.inputDate = false;
      this.manual = false;
      this.propriedades.map(element => {
        if (element.name === e.value.name) {
          this.list = element.constraint.listaItens;
        }
      });
      this.lista = true;
    } else {
      this.inputDate = false;
      this.lista = false;
      this.manual = true;
    }
  }

  getNodeDicionario(id) {
    this.dadosArquivisticoService.listarNodeDicionario(id).subscribe(data => {
      console.log(data);
      this.nodeDicionario = data;
      this.arquivisticoForm.get('nodeDicionario').setValue(this.nodeDicionario);
    }, err => {
      console.error(err);
    });
  }

  getSisArquivistico() {
    this.nodes.map(el => {
      console.log(el);
      if (el.name === 'sis:arquivistico') {
        this.loading = false;
        this.dadosArquivistico = el;
      }
    });
    this.loading = false;
    this.propriedades = this.dadosArquivistico.propriedades;
    console.log(this.propriedades);
  }

  postSubmit() {
    this.submit = false;
    this.arquivisticoForm.get('propriedadeAlfresco').enable();
    this.arquivisticoForm.get('conteudo').setValue(null);
    this.arquivisticoForm.get('id').setValue(null);
  }

  testarPropriedadeExistente() {
    const prop = this.arquivisticoForm.get('propriedadeAlfresco').value;
    this.getArquivisticosEspecifico(this.clienteId, prop.id, this.tipoId);
  }

  getArquivisticosEspecifico(clienteId, propId, tipoId) {
    this.dadosArquivisticoService.listarDadosArquivisticosEspecificos(clienteId, propId, tipoId).subscribe(data => {
      console.log(data);
      if (this.arquivisticoForm.valid) {
          if (data.length < 1) {
            this.salvarBanco();
          } else {
            this.openSnackBarError(`A propriedade já foi criada !`);
            this.submit = false;
          }
      } else {
        this.openSnackBarError('Formulário com erros !');
      }
    }, err => {
      console.error(err);
    });
  }

  getDadosArquivisticos() {
    this.configPastaService.getDicionarioAutoria().subscribe(data => {
      const dadosSistema = data;
      this.nodes = dadosSistema[0].nodes;
      this.getSisArquivistico();
    }, err => {
      this.loading = false;
      console.error(err);
    });
  }

  getCliente(id) {
    this.clienteService.getClienteUnico(id).subscribe(data => {
      this.arquivisticoForm.get('cliente').setValue(data);
    }, err => {
      console.error(err);
    });
  }

  getPropriedadesCadastradas() {
    this.dadosArquivisticoService.listaDadosArquivisticos(this.clienteId, this.tipoId).subscribe(data => {
      console.log(data);
      this.propriedadesCadastradas = data;
    }, err => {
      console.error(err);
    });
  }

  deleteAspecto(id: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar este dado arquivístico ?', from: 'dados-arquivisticos.component.ts'}
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.apagarDadoArquivistico(id);
      }
    });
  }

  compararAspectEdit(obj1, obj2) {
    return obj1 && obj2
      ? obj1.name === obj2.name && obj1.id === obj2.id
      : obj1 === obj2;
  }

  saveOrEdit() {
    if (this.dadoEdit.id !== null && this.dadoEdit.id !== undefined) {
      this.editarMetodo();
    } else {
      this.testarPropriedadeExistente();
    }
  }

  editar(dado) {
    this.dadoEdit = dado;
    this.arquivisticoForm.get('propriedadeAlfresco').disable();
    if (this.dadoEdit.propriedadeAlfresco.type !== 'd:datetime') {
      this.inputDate = false;
      this.manual = true;
    } else {
      this.manual = false;
      this.inputDate = true;
    }
  }

  editarMetodo() {
    this.arquivisticoForm.get('id').setValue(this.dadoEdit.id);
    this.arquivisticoForm.get('cliente').setValue(this.dadoEdit.cliente);
    this.arquivisticoForm.enable();
    this.arquivisticoForm.get('propriedadeAlfresco').setValue(this.dadoEdit.propriedadeAlfresco);
    if (this.arquivisticoForm.valid) {
      this.dadosArquivisticoService.editarDadoArquivistico(this.arquivisticoForm.value).subscribe(data => {
        this.openSnackBarSuccess(`Dado Arquivístico editado com sucesso !`);
        this.submit = false;
        this.getPropriedadesCadastradas();
        this.dadoEdit.id = null;
        this.arquivisticoForm.get('propriedadeAlfresco').enable();
        this.arquivisticoForm.get('conteudo').setValue(null);
      }, err => {
        console.error(err);
        this.openSnackBarError('Erro ao tentar editar o aspecto.');
      });
    } else {
      this.openSnackBarError('Formulário com erros !');
    }
  }

  apagarDadoArquivistico(id) {
    this.loading = true;
    this.dadosArquivisticoService.excluirDadoArquivistico(id).subscribe(() => {
      this.loading = false;
      this.openSnackBarSuccess('Dado arquivístico excluído com sucesso !');
      this.getPropriedadesCadastradas();
    }, err => {
      this.loading = false;
      console.error(err);
      this.openSnackBarError('Erro ao tentar excluir o dado arquivistico.');
    });
  }

  salvarBanco() {
    this.loading = true;
    this.dadosArquivisticoService.salvarDadosArquivisticos(this.arquivisticoForm.value).subscribe(data => {
      this.loading = false;
      this.openSnackBarSuccess(`Propriedade (${data.propriedadeAlfresco.title}) criada com sucesso !`);
      this.getPropriedadesCadastradas();
    }, err => {
      this.loading = false;
      this.openSnackBarError('Erro ao tentar salvar a propriedade !');
      console.error(err);
    });
  }

  onSubmit() {
    this.submit = true;
  }
  
  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/dados-arquivisticos/dados-arquivisticos.component.ts